import { FormControl, InputLabel, NativeSelect, OutlinedInput } from "@mui/material"

const PublicNativeSelect = ({
  id,
  label,
  value,
  onChange,
  data,
  options,
  error = false,
  describedBy,
  required = true,
  style
}) => {
  const labelId = `${id}-label`
  const optionList = options || data || []

  return (
    <FormControl sx={style} required={required} error={error}>
      <InputLabel
        htmlFor={id}
        id={labelId}
        shrink
        sx={{ backgroundColor: "#fff", px: 0.5 }}>
        {label}
      </InputLabel>
      <NativeSelect
        id={id}
        value={value || ""}
        onChange={onChange}
        input={
          <OutlinedInput
            label={label}
            notched
            sx={{
              borderRadius: "8px",
              backgroundColor: "#fff",
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#D8DDE6" },
              "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#AEB6C3" },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0B5CAD",
                borderWidth: 1
              }
            }}
          />
        }
        inputProps={{
          "aria-labelledby": labelId,
          "aria-describedby": describedBy,
          "aria-invalid": error ? "true" : undefined
        }}
      >
        <option value="">Select {label}</option>
        {optionList.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </NativeSelect>
    </FormControl>
  )
}

export default PublicNativeSelect
